import {
    FETCH_PRODUCT_IMAGES,
    FETCH_PRODUCT_IMAGES_FAILURE,
    FETCH_PRODUCT_IMAGES_SUCCESS,
} from 'store/actions/types';

export const fetchProductImages = (payload) => {
    return {
        type: FETCH_PRODUCT_IMAGES,
        payload: payload,
    };
};

export const fetchProductImagesFailure = (error) => {
    return {
        type: FETCH_PRODUCT_IMAGES_FAILURE,
        error: error,
    };
};

export const fetchProductImagesSuccess = (payload, response) => {
    return {
        type: FETCH_PRODUCT_IMAGES_SUCCESS,
        payload: payload,
        response: response,
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/products/images/fetchImages.js